<template>
  <v-card class="pa-5" outlined>
    <v-card-title>
      <h1>Nice Job!</h1>
    </v-card-title>
    <v-card-text>
      <v-form
        v-model="isPasswordFormValid"
        :disabled="isLoading"
        @submit.prevent="setPassword"
      >
        <div class="text-h6"
          >You've confirmed your info, now just set a password and you're good
          to go.</div
        >

        <SetPasswordField @input="password = $event" autofocus />
        <PasswordField
          v-model="password_confirmation"
          :rules="[ValidationRules.requiredString, matchPasswordRule]"
          label="Re-enter Your Password"
        />
        <transition name="fade" mode="out-in">
          <div v-if="error" class="error--text text-h6 my-4">{{ error }}</div>
        </transition>
        <v-btn
          v-if="!showBackButton"
          color="blue darken-2 white--text"
          :disabled="!isPasswordFormValid"
          depressed
          x-large
          type="submit"
          :loading="isLoading"
          block
          >Set My Password</v-btn
        >
        <v-btn
          v-else
          color="amber darken-3 white--text"
          depressed
          x-large
          @click="$emit('back')"
          block
          >Go Back a Step</v-btn
        >
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import SetPasswordField from '@/components/SetPasswordField'
import PasswordField from '@/components/PasswordField'
import { CustomerRoutes } from '@/constants/RouteNames'
import ValidationRules from '@/constants/ValidationRules'

export default {
  name: 'LegacyValidationPasswordCard',
  props: {
    phone: String,
    email: String,
  },
  components: { SetPasswordField, PasswordField },
  data() {
    return {
      isPasswordFormValid: false,
      isLoading: false,
      password: '',
      password_confirmation: '',
      error: null,
      showBackButton: false,
      ValidationRules,
      matchPasswordRule: (v) =>
        v === this.password || `The two fields must match.`,
    }
  },
  methods: {
    ...mapActions('customer', ['setLegacyPassword', 'setCustomerEmail']),
    ...mapActions('snackbars', ['setAccountUpdatedSnackbar']),
    async setPassword() {
      this.isLoading = true
      this.error = null
      try {
        let updatedCustomer = await this.setLegacyPassword(this.password)
        this.setAccountUpdatedSnackbar(true)
        this.setCustomerEmail(updatedCustomer.email)
        this.$router.push({
          name: CustomerRoutes.ORDERS_INDEX,
          query: { welcome: true },
        })
        return updatedCustomer
      } catch (error) {
        let msg = `Sorry, but we couldn't set your password. Please try again.`
        if (error.response && error.response.status === 401) {
          this.showBackButton = true
          msg = `Your session has expired. Please go back and confirm your email once more.`
        }
        this.error = msg
        return Promise.reject(msg)
      } finally {
        this.isLoading = false
      }
    }, // setPassword
  },
}
</script>
